import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function externalDepartmentShortNameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const strValue = typeof value === 'string' ? value : String(value);
    if (/\s/.test(strValue)) {
      return { whitespace: true };
    }
    if (strValue.length > 2) {
      return { maxlength: { requiredLength: 2, actualLength: strValue.length } };
    }
    return null;
  };
}
